import { getAdultExternalMediaNodeNames, getExternalMediaNodeNames } from '../external-media/ExternalMediaProviderRegistry'

export const EXTERNAL_MEDIA_NODE_NAMES = getExternalMediaNodeNames()

export const ADULT_MEDIA_NODE_NAMES = getAdultExternalMediaNodeNames()

export const MEDIA_NODE_NAMES = [
  'image',
  // Draft-only content-import placeholder; counts toward the media cap so an imported draft is
  // validated against the same 20-media limit as native content. See PendingExternalImage.ts.
  'pendingExternalImage',
  // Short-loop clips count toward the same cap as images, and this line is what makes that true --
  // the cap is computed by walking the doc for these names, so a node missing here is a node with no
  // ceiling at all. A clip is also the most expensive media the cap governs, so escaping it would be
  // the worst possible omission: 20 images is a page, 20 clips is up to a gigabyte of egress.
  'clip',
  ...EXTERNAL_MEDIA_NODE_NAMES,
]

const mediaNodeNameSet = new Set<string>(MEDIA_NODE_NAMES)
const externalMediaNodeNameSet = new Set<string>(EXTERNAL_MEDIA_NODE_NAMES)
const adultMediaNodeNameSet = new Set<string>(ADULT_MEDIA_NODE_NAMES)

export function isMediaNodeName(typeName: string | null | undefined): boolean {
  return typeof typeName === 'string' && mediaNodeNameSet.has(typeName)
}

export function isExternalMediaNodeName(typeName: string | null | undefined): boolean {
  return typeof typeName === 'string' && externalMediaNodeNameSet.has(typeName)
}

export function isAdultMediaNodeName(typeName: string | null | undefined): boolean {
  return typeof typeName === 'string' && adultMediaNodeNameSet.has(typeName)
}
